<template>
    <div>
        <v-list class="mb-3">
            <v-list-item class="bordered rounded px-5 mb-3">
                <v-list-item-content>
                    <v-list-item-subtitle>Salary</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-semibold" style="font-size: 20px;">{{moneyFormat(salary, false)}} MYR</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-row>
                <v-col v-if="salaryReport && salaryReport.classes_count !== null" cols="12" md="6">
                    <v-list-item class="bordered rounded px-5">
                        <v-list-item-content>
                            <v-list-item-subtitle>Classes</v-list-item-subtitle>
                            <v-list-item-title class="font-weight-semibold" style="font-size: 20px;">{{numFormat(salaryReport.classes_count)}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col v-if="salaryReport" cols="12" md="6">
                    <v-list-item class="bordered rounded px-5">
                        <v-list-item-content>
                            <v-list-item-subtitle>Total Time</v-list-item-subtitle>
                            <v-list-item-title style="font-size: 20px;"> <span class="font-weight-semibold">{{durationHours}}</span> <span class="muted--text">hours</span></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
            </v-row>
        </v-list>

        <v-card :flat="phoneOnly" class="px-2 bordered rounded">
            <v-card-title class="d-flex justify-space-between">
                <div>
                    {{title || 'Month Salary Report'}}
                </div>
                <div class="px-3">
                    
                </div>
            </v-card-title>
            <v-card-text v-if="!loading" :class="{'px-0': phoneOnly}">
                <v-simple-table v-if="classes && classes.length" class="e-data-table">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    #
                                </th>
                                <th class="text-left">
                                    amount
                                </th>
                                <th class="text-left">
                                    course / program
                                </th>
                                <th class="text-left">
                                    student
                                </th>
                                <th class="text-left">
                                    class duration
                                </th>
                                <th class="text-left">
                                    hour price
                                </th>
                                <th class="text-center">
                                    class date
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="salaryClass in classes" :key="salaryClass.id">
                                <td>#{{salaryClass.id}}</td>
                                <td>
                                    <span class="font-weight-semibold primary--text">{{moneyFormat(salaryClass.paid, false)}} MYR</span>
                                </td>
                                <td>
                                    <span v-if="salaryClass.is_program_class">{{salaryClass.name || (salaryClass.program ? salaryClass.program.name : 'Program Class')}}</span>
                                    <span v-else-if="salaryClass.enrollment && salaryClass.enrollment.course">{{salaryClass.enrollment.course.name}}</span>
                                </td>
                                <td>
                                    <span v-if="salaryClass.is_program_class">__</span>
                                    <span v-else-if="salaryClass.enrollment && salaryClass.enrollment.student">{{salaryClass.enrollment.student.name}}</span>
                                </td>
                                <td><strong>{{salaryClass.duration}}</strong> minutes</td>
                                <td>{{moneyFormat(salaryClass.teacher_hourly_price, false)}} MYR</td>
                                <td class="text-center">{{salaryClass.start_formated}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

                <div v-else-if="!loading">
                    <v-alert color="muted" text class="empty-state-alert">
                        ------------------------------------
                    </v-alert>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        classes: {},
        loading: {type: Boolean, default: false},
        title: {},
        salaryReport: {},
    },
    data(){
        return {}
    },
    methods: {
        ...GlobalMethods,
    },
    computed: {
        ...GlobalComputed,
        salary(){
            return this.salaryReport ? this.salaryReport.salary : '';
        },
        durationHours(){
            return parseFloat((this.salaryReport.classes_duration/60).toFixed(2));
        }
        
    },

}
</script>

<style>

</style>